import {Component, OnInit, HostListener, ViewChild} from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter} from '../../@theme/pipes/dateFormatPicker';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'ngx-muro-trabajoA',
  templateUrl: './muro-trabajoA.component.html',
  styleUrls: ['./muro-trabajoA.component.scss'],
  providers: [UtilidadesService,PeticionesHttpBackEndService,NgbModalConfig, NgbModal,{provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}]
})
export class MuroGrupoTrabajoAComponent implements OnInit {
 
  Token: any;
  openModal:any;
  usuario:any;
  listadoMurosGrupos:any;
  foro:any;
  nombreEditar:any;
  
  descripcionEditar:any;
  checkSociosEditar:any;
  nombreCrear:any;
  descripcionCrear:any;
  checkSociosCrear:any;
  filtrarLista:any;
  listadoMurosGruposFiltrado:any;
  msgError:any;
  descripcion:any;
  numeroPaginaUsuarios:number;
  filtrarListaUsuarios:any;
  listaUsuarios:any;
  listaAddUsuarios:any;
  listaAddUsuariosEliminado:any;
  muroAux:any;
  busquedaActivada:boolean;
  busquedaGeneral:any;
  constructor(private datepip: DatePipe,private _route: ActivatedRoute, private utilidades: UtilidadesService,config: NgbModalConfig, private modalService: NgbModal, private _http : PeticionesHttpBackEndService, private DatePipe: DatePipe,public fb: FormBuilder,private router: Router) { 
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
    config.backdrop = 'static';
    config.keyboard = false;
    this.listadoMurosGrupos = [];
    this.checkSociosEditar = false;
    this.checkSociosCrear = false;
    this.listadoMurosGruposFiltrado = [];
    this.descripcion = "Taller gratuito: Cómo construir una presentación oral eficaz para un colectivo y grupo de trabajo"
    this.msgError = false;
    this.numeroPaginaUsuarios = 0;
    this.listaUsuarios = [];
    this.filtrarListaUsuarios = "";
    this.listaAddUsuarios = [];
    this.muroAux = "";
    this.listaAddUsuariosEliminado = [];
    this.busquedaActivada = false;
    this.busquedaGeneral = "";
  }

  ngOnInit() {
    this._http.getUsuario().subscribe(
      result => {
        this.usuario = result;
        if(this.usuario.Entidad._rol_id !== 1){
          this.router.navigate(['auth/login']);
        }
        this._http.getOneReg("v1/getMurosGrupoTrabajo",this.usuario.Entidad._entidad_id).subscribe(
          result => {
            let resultado:any = result;
            if(resultado.Code == 200){
              this.msgError = false;
              this.listadoMurosGrupos = JSON.parse(JSON.stringify(resultado.MurosGrupos));
              this.listadoMurosGruposFiltrado = JSON.parse(JSON.stringify(resultado.MurosGrupos));
            }else{
              this.msgError = true;
              this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
            }
          });
      }
    );
  }
  onScroll(){
    this.numeroPaginaUsuarios += 20;
    let l = this.filtrarListaUsuarios == "" && this.filtrarListaUsuarios.length < 3 ? 0 : this.filtrarListaUsuarios;
    this._http.getOneReg("v1/getListaUsuarios",this.usuario.Entidad._entidad_id+"/"+this.numeroPaginaUsuarios+"/"+l+"/"+this.muroAux.MuroId).subscribe(
      result => {
        let resultado:any = result;
        if(resultado.Code == 200){
          resultado.Usuarios.forEach(element => {
            this.listaUsuarios.push(element);
          });

        }else{
          this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
        }
      });
  }
  navegarMuroFormativo(evento){
    let parametros: NavigationExtras = {
      queryParams: { 'm': evento.MuroId}
    };
    this.router.navigate(['private/muro-grupo'],parametros);
  }


  anadirUsuarios(content,muro) {
  this.numeroPaginaUsuarios = 0;
  this.listaAddUsuarios = [];
  this.listaAddUsuariosEliminado = [];
  this.muroAux = muro;
  this._http.getOneReg("v1/getListaUsuarios",this.usuario.Entidad._entidad_id+"/"+this.numeroPaginaUsuarios+"/"+0+"/"+this.muroAux.MuroId).subscribe(
    result => {
      let resultado:any = result;
      if(resultado.Code == 200){
        this.listaAddUsuarios = resultado.Participantes;
        this.listaUsuarios = resultado.Usuarios;
        this.openModal = this.modalService.open(content);
      }else{
        this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
      }
    });
 
}
modalEliminar(content,muro){
  this.muroAux = muro;
  this.openModal = this.modalService.open(content);

}
modalEditar(content,muro){
  this.muroAux = muro;
  this.nombreEditar = this.muroAux.Nombre;
  this.descripcionEditar = this.muroAux.Descripcion;
  this.openModal = this.modalService.open(content);
}


modalCrear(content) {
    this.openModal = this.modalService.open(content);

}

eliminarMuro(muro){
  this._http.insertaObjecto("v1/eliminarMuroGrupo",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"muro":muro.MuroId}}).subscribe(
    result => {
      let resultado :any = result;
      if(resultado.Code == 200){
        this.listadoMurosGrupos = JSON.parse(JSON.stringify(resultado.MurosGrupos));
        this.listadoMurosGruposFiltrado = JSON.parse(JSON.stringify(resultado.MurosGrupos));
        this.openModal.close();
        this.utilidades.notificationSuccess("Aviso","El muro se ha eliminado correctamente","top-left");
      }else{
        this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
      }
    },
    error => {
    }
  );
}
editarMuroGrupo(muro){
  if((this.nombreEditar !== null  && this.nombreEditar !== undefined && this.nombreEditar.length > 0) && (this.descripcionEditar !== null  && this.descripcionEditar !== undefined && this.descripcionEditar.length > 0)){
    this._http.insertaObjecto("v1/editarMuroGrupo",{Data: {"entidadId":this.usuario.Entidad._entidad_id,
    "muro":muro.MuroId,"nombre":this.nombreEditar,"descripcion":this.descripcionEditar}}).subscribe(
      result => {
        let resultado :any = result;
        if(resultado.Code == 200){
          this.listadoMurosGrupos = JSON.parse(JSON.stringify(resultado.MurosGrupos));
          this.listadoMurosGruposFiltrado = JSON.parse(JSON.stringify(resultado.MurosGrupos));
          this.openModal.close();
          this.utilidades.notificationSuccess("Aviso","El muro se ha editado correctamente","top-left");
        }else{
          this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
        }
      },
      error => {
      }
    );
  }else{
    this.utilidades.notificationWarning("Aviso","Debe rellenar los campos \"Nombre\" y \"Descripción\"","top-left");

  }
  
}

addUsuariosParticipantes(){
  if(this.listaAddUsuarios.length > 0){
    this._http.insertaObjecto("v1/addParticipantes",{Data: {"entidadId":this.usuario.Entidad._entidad_id,
    "muro":this.muroAux.MuroId,"participantes":this.listaAddUsuarios,"participantesBorrados":this.listaAddUsuariosEliminado}}).subscribe(
      result => {
        let resultado :any = result;
        if(resultado.Code == 200){
          this.listadoMurosGrupos = JSON.parse(JSON.stringify(resultado.MurosGrupos));
          this.listadoMurosGruposFiltrado = JSON.parse(JSON.stringify(resultado.MurosGrupos));
          this.openModal.close();
          this.utilidades.notificationSuccess("Aviso","Se han añadido los participantes correctamente","top-left");
        }else{
          this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
        }
      },
      error => {
      }
    );
  }else{
    this.utilidades.notificationWarning("Aviso","Debe seleccionar minimo un usuario","top-left");

  }
}
buscarUsuarios(){
  this.numeroPaginaUsuarios = 0;
  if(this.filtrarListaUsuarios.length >= 3){
    this._http.getOneReg("v1/getListaUsuarios",this.usuario.Entidad._entidad_id+"/"+this.numeroPaginaUsuarios+"/"+this.filtrarListaUsuarios+"/"+this.muroAux.MuroId).subscribe(
      result => {
        let resultado:any = result;
        if(resultado.Code == 200){
          this.listaUsuarios = resultado.Usuarios;
  
        }else{
          this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
        }
      });
  }
  if(this.filtrarListaUsuarios.length == 0){
    this._http.getOneReg("v1/getListaUsuarios",this.usuario.Entidad._entidad_id+"/"+this.numeroPaginaUsuarios+"/"+0+"/"+this.muroAux.MuroId).subscribe(
      result => {
        let resultado:any = result;
        if(resultado.Code == 200){
          this.listaUsuarios = resultado.Usuarios;
        }else{
          this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
        }
      });
  }
}

addUsuario(usuarios){
  let avisoRegistrado = false;
  this.listaAddUsuarios.forEach(element => {
    if(usuarios.EntidadId == element.EntidadId){
      avisoRegistrado = true;
    }
  });
  if(!avisoRegistrado){
    usuarios.Existe = 0;
    this.listaAddUsuarios.push(usuarios);
  }
}

deleteUsuario(position,user){
  if(user.Existe !== undefined && user.Existe == 1){
    this.listaAddUsuariosEliminado.push(user);
  }
  this.listaAddUsuarios.splice(position,1);
}

buscar(){
  this.listadoMurosGruposFiltrado = JSON.parse(JSON.stringify(this.listadoMurosGrupos))
  if(this.filtrarLista !== ""){
    this.listadoMurosGruposFiltrado = [];
    this.listadoMurosGrupos.forEach(element => {
      if((this.filtrar_acentos(element.Nombre).indexOf(this.filtrar_acentos(this.filtrarLista)) !== -1)){
        this.listadoMurosGruposFiltrado.push(element);
      }
    });
  }
}
filtrar_acentos(input){
  var acentos = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç";
  var original = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";
  for (var i = 0; i < acentos.length; i++) {
      input = input.replace(acentos.charAt(i), original.charAt(i)).toLowerCase();
  };
  return input;
}

crearNuevoMuro(){
  if((this.nombreCrear !== null  && this.nombreCrear !== undefined && this.nombreCrear.length > 0) && (this.descripcionCrear !== null  && this.descripcionCrear !== undefined && this.descripcionCrear.length > 0)){
    this._http.insertaObjecto("v1/nuevoMuroTrabajo",{Data: {"entidadId":this.usuario.Entidad._entidad_id,"nombre":this.nombreCrear,"descripcion":this.descripcionCrear}}).subscribe(
      result => {
        let resultado :any = result;
        if(resultado.Code == 200){
          this.listadoMurosGrupos.push(resultado.MurosGrupos[0]);
          this.listadoMurosGruposFiltrado.push(resultado.MurosGrupos[0]);
          this.openModal.close();
          this.utilidades.notificationSuccess("Aviso","El muro se ha creado correctamente","top-left");
        }else{
          this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
        }
      },
      error => {
      }
    );
  }else{
    this.utilidades.notificationWarning("Aviso","Debe rellenar los campos \"Nombre\" y \"Descripción\"","top-left");

  }
}
buscarActivado(){
  this.busquedaActivada = !this.busquedaActivada;
}

onSearch(){
  let parametros: NavigationExtras = {
    queryParams: { 'nom': this.busquedaGeneral }
  };
  this.router.navigate(['private/buscador'], parametros);
}

  
}
